import enLocale from 'element-ui/lib/locale/lang/en'

const en = {
    navbar: {
        'home': 'Home',
        'blog': 'Blog',
        'language': 'Language'
    },
    pageTitle: {
        'index': 'G-Lab online tools',
        'timeClac': 'Time Calculator',
        'idPhotoEditor': 'ID Photo Editor',
        'imgSplitter': 'Image Spiltter',
        'lifeRestart': 'Life Restart',
        'stopwatch': 'Stopwatch'
    },
    tools: {
        timeClac: {
            'introductionSimple': 'Calculate the time difference between two time points.',
            'introduction': 'Calculate the time difference between two time points, and display the calculation results in different time levels, and can be adjusted and recalculated at different time levels. Can be used for calculations of work time, anniversaries and specific date intervals.',
            'startZone': 'Start',
            'finshZone': 'Finsh',
            'otpZone': 'Options',
            'startDate': 'Start Date',
            'finshDate': 'Finsh Date',
            'datePlaceholder': 'Pick a day',
            'startTime': 'Start Time',
            'finshTime': 'Finsh Time',
            'timePlaceholder': 'Select Time',
            'more': 'more',
            'resultZone': 'Result',
            'totalZone': 'Total',
            'optResultZone': 'Options Results',
            'result': 'Time Interval',
            'totalDays': 'Total Days',
            'totalHours': 'Total Hours',
            'totalMinutes': 'Total Minutes',
            'totalSeconds': 'Total Seconds',
            'dateRuleRequired': 'Please pick a date',
            'timeRuleRequired': 'Please pick a time',
            'year': 'year(s)',
            'month': 'month(s)',
            'day': 'day(s)',
            'hour': 'hour(s)',
            'minute': 'minute(s)',
            'second': 'second(s)'
        },
        idPhotoEditor: {
            'introductionSimple': '。',
            'introduction': '。',
            'customize': 'Customize',
            'standard': 'Standard',
            'width': 'W',
            'height': 'H',
            'importImg': 'Import Image',
            'reset': 'Reset',
            'cropImg': 'Crop Image',
            'scaleTip': 'The setting exceeds the actual size of the original image, and the cropping result will be enlarged proportionally, which may cause a reduction in the picture clarity!',
            standards: {
                '1': '1 inch'
            }
        },
        imgSplitter: {
            'introductionSimple': 'You can split the picture into n * m blocks for weibo, ins etc., also for ACNL!',
            'introduction': 'You can split the picture into n * m blocks for weibo, ins etc., also for ACNL!',
            'row': 'Rows',
            'column': 'Columns',
            'importImg': 'Import Image',
            'splitImg': 'Split Image',
            'saveAs': 'Save As',
            'toAcnlTool': 'ACNL Pattern Tool'
        },
        lifeRestart: {
            'introductionSimple': 'Life restart remake！'
        },
        stopwatch: {
            'introductionSimple': 'Online Stopwatch with lap times.',
            'introduction': 'Online Stopwatch with lap times.Shortcuts: "Spacebar" to "Start/Pause";Key "S" to Split";Key "R" to "Reset"',
            'start': 'start',
            'record': 'split',
            'stop': 'stop' ,
            'reset': 'reset',
            'gap': 'Split',
            'gapTime': 'Interval',
            'totalTime': 'Total',
            'pause': 'PAUSE',
            'setInit': 'SET',
            'editTime': 'start time',
            'hour': 'Hour',
            'minute': 'Minute',
            'second': 'Second',
            'millisecond': 'Millisecond',
            'confirm': 'confirm',
            'cancel': 'cancel'
        }
    },
    components: {
        imgLoader: {
            tip1: 'Drop image here or',
            tip2: 'select',
            unsupportedErr: 'Your browser is not supported.',
            imgTypeErr:'Please choose an image file.'
        }
    },
    ...enLocale
}

export default en